/**
 * Created by yangxx on 2017/8/21.
 * 实现js的切面
 */
'use strict';
(function(fun){
    function isFunction(fn){
        return Object.prototype.toString.call(fn)=='[object Function]';
    }
    function isPromise(obj){
        return obj instanceof Promise;
    }
    /**
     *
     * @param advice
     */
    fun.prototype.before=function(advice){
        var _self=this;
        return function(){
            if(isFunction(advice)){
                if(advice.apply(this,arguments)===false){
                    return false;
                }
            }
            return _self.apply(this,arguments);
        }
    }
    /**
     *
     * @param advice
     */
    fun.prototype.after=function(advice){
        var _self=this;
        return function(){
            var _result=_self.apply(this,arguments);
            if(_result===false){
                return false;
            }
            if(isFunction(advice)){
                if(isPromise(_result)){
                    var _self_=this,
                        _args_=arguments;
                    _result.then(function(){
                        var _args=[];
                        for(var k in arguments){
                            _args.push(arguments[k]);
                        }
                        _args.push(_args_);
                        advice.apply(_self_,_args);
                    });
                }else{
                    advice.apply(this,arguments);
                }
            }
            return _result;
        }
    }

    /**
     *
     * @param before
     * @param after
     */
    fun.prototype.around=function(before,after){
        var _self=this;
        return function(){
            if(isFunction(before)){
                if(before.apply(this,arguments)===false){
                    return false;
                }
            }
            var _result=_self.apply(this,arguments);
            if(_result===false){
                return false;
            }
            if(isFunction(after)){
                if(isPromise(_result)){
                    var _self_=this,
                        _args_=arguments;
                    _result.then(function(){
                        var _args=[];
                        for(var k in arguments){
                            _args.push(arguments[k]);
                        }
                        _args.push(_args_);
                        after.apply(_self_,_args);
                    });
                }else{
                    after.apply(this,arguments);
                }
            }
            return _result;
        }
    }
})(Function);